import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertImageUI from './insertimageui';

export default class InsertImage extends Plugin {
  static get pluginName() {
    return 'InsertImage';
  }

  static get requires() {
    return [InsertImageUI];
  }
}
